import React from 'react'
import TableRow from '../../UI/TableRow'
import ChartIcon from '@material-ui/icons/InsertChart'
import DriversIcon from '@material-ui/icons/DirectionsCar'
import MoreIcon from '@material-ui/icons/MoreHoriz'
import ToolTip from '../../UI/ToolTip'
import {
  TwoLineItemWithColor,
  ToolTipContainer,
  SingleItemBoldColor,
  LeftSideColor
} from '../../UI/TableItem'

type Props = {
  projectNumber: string
  haulId: string
  KPIs: {
    driveTime: number
    timeOnSite: number
    timeAtDumpSite: number
    productionTotal: number
    productionTotalByTruck: {}
    tripsByTruck: {}
  }
  productionUnits: string
  haulLogCount: number
  history: {
    push: (path: string) => void
  }
  index: number
  mostRecentActiveDay: string
  handleDriverInfoModal(haulId: string): void
  view: string
}

const KpiItem = ({
  projectNumber,
  haulId,
  KPIs,
  productionUnits,
  haulLogCount,
  history,
  index,
  mostRecentActiveDay,
  handleDriverInfoModal,
  view
}: Props) => {
  const color = LeftSideColor(index)
  const hasTrips = haulLogCount > 0
  if (!hasTrips) {
    mostRecentActiveDay = 'No trips'
  }
  return (
    <TableRow key={haulId}>
      {view === 'mostRecent' ? (
        <TwoLineItemWithColor
          color={color.color}
          text={haulId}
          subText={mostRecentActiveDay}
          width="12"
        />
      ) : (
        <SingleItemBoldColor color={color.color} text={haulId} width="12" />
      )}
      <SingleItemBoldColor
        text={hasTrips ? `${(KPIs.driveTime / haulLogCount).toFixed(1)} mins` : 'No trips'}
        width="10"
      />
      <SingleItemBoldColor
        text={hasTrips ? `${(KPIs.timeOnSite / haulLogCount).toFixed(1)} mins` : 'No trips'}
        width="10"
      />
      <SingleItemBoldColor
        text={hasTrips ? `${(KPIs.timeAtDumpSite / haulLogCount).toFixed(1)} mins` : 'No trips'}
        width="14"
      />
      <SingleItemBoldColor
        text={
          hasTrips
            ? `${(KPIs.productionTotal / haulLogCount).toFixed(0)} ${productionUnits}`
            : 'No trips'
        }
        width="14"
      />
      <SingleItemBoldColor
        text={hasTrips ? `${KPIs.productionTotal} ${productionUnits}` : 'No trips'}
        width="14"
      />
      <ToolTipContainer>
        <ToolTip title="More Details" idName="haulIcon">
          <ChartIcon
            className="actionsIcon"
            onClick={() => history.push(`/app/dashboard/${projectNumber}/hauls/${haulId}/graphs`)}
          />
        </ToolTip>
        <ToolTip title="Driver Info" idName="haulIcon">
          <DriversIcon className="actionsIcon" onClick={() => handleDriverInfoModal(haulId)} />
        </ToolTip>
        <MoreIcon className="actionsIcon" />
      </ToolTipContainer>
    </TableRow>
  )
}

export default KpiItem
